<div *ngIf="loading" class="loading"></div>
<div [hidden]="loading">
    <smt-workflow-header 
        [costCenter]="currentPage?.shiftRecord?.costCenter" 
        [shiftBlock]="currentPage?.shiftRecord?.shiftBlock" 
        [workflowTime]="currentPage?.shiftRecord?.workflowTimeFacility"
        (saveCompleted)="loadComponent()">
    </smt-workflow-header>
    <smt-staffing-plan-page-header [currentPage]="currentPage"></smt-staffing-plan-page-header>
    <ng-template page-host></ng-template>
    <smt-staffing-plan-page-footer [currentPage]="currentPage" [isFormValid]="isFormValid" (doneClicked)="done()" (nextClicked)="next()" (previousClicked)="previous()" (skipClicked)="skip()"></smt-staffing-plan-page-footer>
</div>
<div *ngIf="error" class="saving-error warning">An error occurred. Please try again.</div>